import { render, staticRenderFns } from "./model2.vue?vue&type=template&id=b84ea268&scoped=true&"
import script from "./model2.vue?vue&type=script&lang=js&"
export * from "./model2.vue?vue&type=script&lang=js&"
import style0 from "./model2.vue?vue&type=style&index=0&id=b84ea268&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84ea268",
  null
  
)

export default component.exports